import React from 'react';

type ContentWrapProps = {
	children: React.ReactNode;
	wide?: boolean;
	className?: string;
	style?: React.CSSProperties;
};

const ContentWrap = ({ children, wide = false, className = '', style }: ContentWrapProps) => (
	<div
		className={`relative w-full ${wide ? 'max-w-[1030px]' : 'max-w-[710px]'} px-contentSmall mx-auto ${className}`.trim()}
		style={style}
	>
		{children}
	</div>
);

export default ContentWrap;
